angular.module('shared-components.popup', []);